<template>
    <div class="preloader" :class="{ 'preloader--global': is_global, 'preloader--hidden': !show, 'preloader--static': is_static }">
        <div class="loader" />
    </div>
</template>
<script src="./preloader.js"></script>
<style src="./preloader.scss" lang="scss" scoped />
